import * as actionTypes from './actionTypes';

export const refreshCounters = (counters) => ({
    type: actionTypes.REFRESH_COUNTERS,
    payload: {counters}
})
